<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.allergies', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body" v-if="can">
                <!--                <h3 class="card-title text-center mb-0">-->
                <!--                    {{$tc('message.medicalFiles',1)}} :{{dossier}}-->
                <!--                </h3>-->
                <b-form @reset="onReset" v-if="show">
                    <b-container>
                        <div class="form-group col-md-12">
                            <span class="obligatoire">*</span>
                            <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                            <autocomplete
                                :search="getEtablisssements"
                                placeholder="Rechercher l'établissement"
                                aria-label="Rechercher l'établissement"
                                :get-result-value="getValueEtablissement"
                                @submit="chooseEtablissement"
                            ></autocomplete>
                            <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                            <small id="emailHelp" class="form-text text-danger" v-if="$v.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                        </div>
                        <b-row class="p-0">
                            <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                    <multiselect v-model="$v.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                    <b-form-invalid-feedback v-if="$v.activity_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('activity_id')" style="color:red">
                                        {{getErrorsField('activity_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="allergiesACreer-group"
                                        :label="$t('message.description')"
                                        label-for="allergiesACreer-0">
                                    <b-form-input
                                            id="allergiesACreer-0"
                                            v-model="$v.allergiesACreer.$model"
                                            :state="$v.allergiesACreer.$dirty ? !(errorshasField('allergiesACreer') || $v.allergiesACreer.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('allergiesACreer')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.allergiesACreer.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.allergiesACreer.minLength">
                                        {{ $t('message.minCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('allergiesACreer')" style="color: red">
                                        {{ getErrorsField('allergiesACreer') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
            <div class="card-body">
                <h3 class="card-title text-center mb-0">
                    {{ $tc('message.allergies', 2) }}
                </h3>

                <b-row >
                    <b-col sm="12">
                        <b-row >
                            <template v-if="rows">
                                <b-table
                                        id="allergies-table"
                                        primary-key="id"
                                        :per-page="perPage"
                                        :current-page="currentPage"
                                        selectable
                                        select-mode="single"
                                        borderless
                                        responsive
                                        striped
                                        hover
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        @row-selected="rowSelected"
                                        :fields="fields"
                                        :items="allergies"
                                >
                                    <!-- A virtual compositeumn for actions -->
                                    <template slot="action" slot-scope="data" >
                                        <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                            <div class="col-sm-6">
                                                <b-link :to="{ name: 'edit-allergy', params: { allergy: data.item.slug } }" v-if="data.item.isAuthor || hasAdminRole">
                                                    <i class="fas fa-edit fa-2x edit-icon"></i>
                                                </b-link>
                                            </div>

                                            <div class="col-sm-6">
                                                <i v-b-modal="'delete-modal-' +data.item.slug " class="fas fa-trash fa-2x delete-icon"></i>
                                            </div>
                                        </div>

                                        <b-modal
                                                :id="'delete-modal-' + data.item.slug"
                                                size="sm"
                                                header-bg-variant="danger"
                                                header-text-variant="light"
                                                :title="$t('message.delete') + ' ' + $tc('message.allergies', 1)"
                                                hide-footer
                                        >
                                            <div class="d-block text-center">
                                                <h3>{{ $t('message.delete') }} {{ data.item.description }}?</h3>
                                            </div>

                                            <div class="d-block float-right">
                                                <b-button variant="danger" @click="removeAllergy(data.item.slug,data.item.id)">
                                                    {{ $t('message.delete') }}
                                                </b-button>
                                                <b-button variant="secondary" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                                    {{ $t('message.cancel') }}
                                                </b-button>
                                            </div>
                                        </b-modal>
                                    </template>
                                </b-table>
                                <b-pagination
                                        class="justify-content-center"
                                        v-model="currentPage"
                                        :total-rows="rows"
                                        :per-page="perPage"
                                        aria-controls="allergies-table"
                                ></b-pagination>
                            </template>

                            <template v-else>
                                <div class="card">
                                    <div class="card-body text-xs-center">
                                        <p class="card-text">
                                            {{ $t('message.noResults') }}
                                        </p>
                                    </div>
                                </div>
                            </template>
                        </b-row>
                    </b-col>
                    <!--                    <b-col v-for="(allergy,index) in allergies" :key="index" sm="6"  >-->
                    <!--                        <div v-if="allergies.length > 0">-->
                    <!--                            {{allergy.description}}  {{formattedDate(allergy.date)}}-->
                    <!--                            <b-link :to="{ name: 'edit-allergy', params: { allergy: allergy.slug } }" v-if="allergy.isAuthor || hasAdminRole">-->
                    <!--                                <i class="fas fa-edit edit-icon"></i>-->
                    <!--                            </b-link>-->
                    <!--                            <span class="ml-2" v-if="allergy.isAuthor || hasAdminRole">-->
                    <!--                            <i v-b-modal="'delete-modal-' +allergy.slug " class="fas fa-trash delete-icon"></i>-->
                    <!--                        </span>-->
                    <!--                            <b-modal-->
                    <!--                                    :id="'delete-modal-' + allergy.slug"-->
                    <!--                                    size="sm"-->
                    <!--                                    header-bg-variant="danger"-->
                    <!--                                    header-text-variant="light"-->
                    <!--                                    :title="$t('message.delete') + ' ' + $tc('message.allergies', 1)"-->
                    <!--                                    hide-footer-->
                    <!--                            >-->
                    <!--                                <div class="d-block text-center">-->
                    <!--                                    <h3>{{ $t('message.delete') }} {{ allergy.description }}?</h3>-->
                    <!--                                </div>-->

                    <!--                                <div class="d-block float-right">-->
                    <!--                                    <b-button variant="danger" @click="removeAllergy(allergy.slug,allergy.id)">-->
                    <!--                                        {{ $t('message.delete') }}-->
                    <!--                                    </b-button>-->
                    <!--                                    <b-button variant="secondary" @click="$bvModal.hide('delete-modal-' + allergy.slug)">-->
                    <!--                                        {{ $t('message.cancel') }}-->
                    <!--                                    </b-button>-->
                    <!--                                </div>-->
                    <!--                            </b-modal>-->
                    <!--                        </div>-->
                    <!--                    </b-col>-->
                </b-row>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapGetters } from 'vuex';
    import AppConfig from "../../constants/AppConfig";
    import axios from "axios";
    import {minLength,required} from "vuelidate/lib/validators";
    import Multiselect from 'vue-multiselect'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'    
    export default {
        name: "AddAllergy",
        components: {
            Multiselect,
            Autocomplete
        },
        computed: {
            ...mapGetters(['errors','file',
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPraticienRole',
            ]),
            mFile: function() {
                return this.file;
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            dossier:function () {
                if ( typeof  this.mFile== 'object'){
                    return  this.file.numero_dossier;
                }
                return "";
            },
            allergies:function () {
                if ( typeof  this.mFile.allergies == 'object')
                    return   this.mFile.allergies;
                return [];
            },

            rows: function() {
                if ( typeof  this.mFile.allergies== 'object'){
                    return  this.file.allergies.length;
                }
                return 0;
            },
        },

        data() {
            return {
                show: true,
                file_id: this.$route.params.file,
                allergiesACreer:'',
                activity_id:'',
                etablissement_id:null,
                perPage: 10,
                currentPage: 1,
                missions: [],
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description', 1),
                    },
                    // {
                    //     key: 'date',
                    //     label: this.$i18n.t('message.startDate'),
                    // },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,

            }
        },

        methods: {
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.etablissement_id = result.id;
            },
            rowSelected(items) {
                this.$router.push({ name: 'allergy', params: { allergy: items[0].slug } });
            },

            updateAllergy(slug) {
                this.$router.push({ name: 'edit-allergy', params: { allergy: slug } });
            },
            getGroupeActivites: function () {
                if(this.hasMedecinControleRole){
                    axios.get(AppConfig.apiUrl + "/referent-activites/list")
                    .then((res) => (this.missions = res.data.activites))
                    .catch((error) => {window.console.log(error)});
                }else{
                    axios.get(AppConfig.apiUrl + "/mission/list")
                        .then((res) => {this.missions = res.data.activites.map((x )=> ({
                            id: x.id,
                            description_fr: x.description_fr
                        }))})
                        .catch((error) => {window.console.log(error)});
                }

            },
            removeAllergy(slug,id) {
                let self = this;
                let argAllergies = [];
                argAllergies.push(id);
                let args = {
                    allergies: argAllergies,
                    dossier:this.file.id
                };

                let successMessage = this.$i18n.t('message.allergyDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('removeAllergy', { args, index: slug, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal-' + slug);
                });
            },

            formattedDate(date) {
                return date ? moment(date).format('DD-MM-YYYY') : '';
            },

            getFile() {
                let args = {
                    file: this.file_id
                };
                this.$store.dispatch("getMedicalFile", { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                this.$v.$touch();

                if (!this.$v.$invalid ){
                    let args = {
                        dossier: this.mFile.id,
                        allergiesACreer:this.allergiesACreer,
                        etablissement_id: this.etablissement_id,
                        activity_id: this.activity_id,
                    };

                    let successMessage = this.$i18n.t('message.allergyCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('addAllergy', { args, errorMessages, successMessage }).then(() => {
                        this.allergiesACreer = '';
                        this.etablissement_id = '';
                        this.activity_id = '';
                        this.$v.allergiesACreer.$reset();
                    });
                }

            },

            onReset: function(evt) {
                // evt.preventDefault();
                //
                // // Reset our form values
                // this.form.intitule = '';
                // this.form.description = '';
                //
                // // Trick to reset/clear native browser form validation state
                // this.show = false;
                //
                // this.$nextTick(() => {
                //     this.show = true;
                // });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
        },


        mounted() {
            this.getFile();
            this.getGroupeActivites();
        },
        validations() {
            return {
                activity_id:{
                    required
                },
                etablissement_id:{required},
                allergiesACreer:{
                    required,
                    minLength: minLength(3)
                }
            }
        }
    }
</script>

<style scoped>

</style>